module.exports = __webpack_public_path__ + "img/escabeche.3617e5c3.jpeg";